import React from "react";

function HeaderBackgroundPortrait(props) {
  return (
    <svg
      width="1280px"
      height="2404px"
      viewBox="0 0 1280 2404"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      link="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <linearGradient
          x1="50%"
          y1="100%"
          x2="50%"
          y2="0%"
          id="linearGradient-1"
        >
          <stop stopColor="#5D21D3" offset="0%"></stop>
          <stop stopColor="#3721D2" offset="100%"></stop>
        </linearGradient>
        <path
          d="M1280,0 L1280,2324.97841 C1134.29917,2330.49573 1033.63251,2336.74521 978,2343.72683 C808.326695,2365.02005 738.08254,2386.57334 640,2398.12228 C598.100354,2403.05584 396.603291,2415.51047 223.538574,2370.74218 C145.938574,2350.66866 71.4257157,2335.41407 1.8189894e-12,2324.97841 L1.8189894e-12,0 L1280,0 Z"
          id="portrait-bg-path-2"
        ></path>
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g>
          <mask id="portrait-bg-mask-3" fill="white">
            <use href="#portrait-bg-path-2"></use>
          </mask>
          <use
            id="Rectangle-Copy-3"
            fill="url(#linearGradient-1)"
            href="#portrait-bg-path-2"
          ></use>
          <path
            d="M-881.575385,1780.40769 C-888.34764,1655.29432 -895.119894,1530.13719 -896.756693,1404.85284 C-897.380722,1356.75149 -897.298882,1308.35502 -890.301568,1260.64853 C-883.887363,1217.00469 -877.493619,1173.22142 -840.993009,1143.9057 C-768.759039,1085.88488 -670.397672,1057.33752 -579.657647,1045.55872 C-519.382538,1037.73265 -458.636848,1037.90667 -397.921849,1038.0807 C-371.722841,1038.15601 -345.534063,1038.23132 -319.386204,1037.66344 C-164.647354,1034.30403 26.4488869,1025.62411 147.694746,1136.57117 C197.340894,1181.98988 218.302147,1247.37779 268.797385,1291.0715 C313.297847,1329.58209 368.263592,1339.96564 421.848287,1360.05391 C476.957251,1380.71516 530.920456,1408.70075 570.050173,1453.59025 C604.167195,1492.74403 624.013378,1541.23922 641.578274,1589.38738 C658.549829,1635.85838 670.09949,1690.66431 707.449189,1725.69031 C737.934563,1754.27329 779.744538,1764.11033 817.339757,1779.75942 C858.413173,1796.85059 899.261528,1825.87219 926.094796,1861.54443 C971.700098,1922.14511 953.593013,2005.90649 995.740578,2068.08764 C1034.32811,2125.0175 1102.34732,2152.1696 1158.65319,2187.68715 C1206.7853,2218.05516 1256.04476,2260.97135 1273.22603,2318.04368 C1294.74481,2389.52657 1264.41698,2443.56617 1190.4787,2455.80904 C1140.1676,2464.13378 1089.38592,2462.99396 1038.60424,2461.84397 C1008.37462,2461.16211 978.134763,2460.48026 947.986978,2461.80326 C876.612327,2464.91741 805.605957,2466.85103 733.709577,2470.37225 C565.753577,2478.58505 397.142858,2475.26736 229.729047,2492.97525 C224.706121,2493.50446 219.683196,2494.05401 214.6705,2494.62392 C115.695332,2505.84909 20.1779021,2517.73577 -76.5568971,2541.45824 C-183.429618,2567.6537 -289.647619,2596.38323 -395.834931,2625.17382 C-466.810611,2644.40825 -539.003661,2664.42631 -612.51638,2661.75995 C-686.018868,2659.10377 -762.518745,2629.91628 -803.65354,2569.25148 C-838.282061,2518.18356 -843.253837,2453.42763 -847.018474,2391.93851 C-855.294537,2256.77845 -862.946571,2121.57769 -870.373545,1986.36675 C-874.138181,1917.71814 -877.861898,1849.06241 -881.575385,1780.40769 Z"
            id="bg-fill"
            fill="#EBF6F1"
            opacity="0.0792410714"
            mask="url(#portrait-bg-mask-3)"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default HeaderBackgroundPortrait;
